// Index file for the directory. Don't add anything else here.
import CarouselYogatimeSearch from './CarouselYogatimeSearch';
export default CarouselYogatimeSearch;
